<template>
<div>

<compFormEdit ref="formbase" class="margin-layout" :formdata="getBase" v-model="formData"  :labelWidth="100"></compFormEdit>
  <vButtonGroup class="text-right">
          <vButton @click="submit" theme="primary">{{$t('global.modal.confirm', { defaultValue: "确定" })}}</vButton>
          <vButton @click="cancel">{{$t('global.common.cancel', { defaultValue: "取消" })}}</vButton>
  </vButtonGroup>
  <vLoading loading size="large" transfer v-if="loading"></vLoading>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import mixin from "../mixin";
import {
    HttpAddressList,
    HttpSaveTimePrediction,
    HttpGetOne
} from "@/service/logistics";
export default {
  mixins: [mixin],
  props: ["activeid","type", "timeType"],
  created() {
    this.getDetail();
    this.getAddress();
      
  },
  data() {
    return {
      loading: false,
      id:  this.activeid,
      addressCodeList:[],
      formData: {
          destinationType:0,
      },
      required: [
        {
          required: true,
          message: "该信息不能为空,请填写"
        }
      ],
    };
  },
  computed: {
      ...mapGetters('dictionary', ['getCompanyList','getFBBFilterDisabledAllWarehouse',"getSystemPortList"]),
        isAdd() {
			return this.type === 'add'
        },
        isOcean() {
			return this.timeType === 'ocean'
		},
        isPort() {
			return this.timeType === 'port'
		},
        isPallet() {
			return this.timeType === 'pallet'
		},
        isAmazon() {
			return this.timeType === 'amazon'
		},
        isSailWait() {
			return this.timeType === 'sail_wait'
        },
        isWarehouse() {
			return this.formData.destinationType === 0
		},
     getBase() {
			return [{
				label: this.$t('fbb.headlogistics.forwarder', { defaultValue: '货代公司' }),
				key: this.isAdd ? "carrierId" : "carrier",
        tag: "vSelect",
        query:!this.isAdd,
        span:24,
				options: this.isAdd ? this.getCompanyList : null,
				props: {
        filterable: true
            },
        on: {
						'on-attach': (val) => this.formData.carrier = val.name
					}
			},{
				label: this.$t('fbb.headlogistics.ship_port', { defaultValue: '发运港' }),
        key: this.isAdd ? "shipPortId" : "shipPort",
        show:this.isOcean||this.isSailWait,
        span:24,
        query:!this.isAdd,
				tag: "vSelect",
        options: this.isAdd ? this.getSystemPortList : null,	
        on: {
						'on-attach': (val) => this.formData.shipPort = val.title
					}			
			},{
				label: this.$t('fbb.headlogistics.purpose_port', { defaultValue: '目的港' }),
        key: this.isAdd ? "purposePortId" : "purposePort",
        show:this.isOcean,
        span:24,
        query:!this.isAdd,
				tag: "vSelect",
        options: this.isAdd ? this.getSystemPortList : null,	
          on: {
						'on-attach': (val) => this.formData.purposePort = val.title
					}			
			},{
				label: this.$t('fbb.logistics.cost_port', { defaultValue: '港口' }),
        key: this.isAdd ? "purposePortId" : "purposePort",
        tag: "vSelect",
        span:24,
        query:!this.isAdd,
        show:this.isPort,
        options: this.isAdd ?  this.getSystemPortList : null,	
        on: {
						'on-attach': (val) => this.formData.purposePort = val.title
					}				
			},{
				label: this.$t('fbb.logistics.time_destination_type', { defaultValue: '类别' }),
				key: "destinationType",
        tag: "vSelect",
        span:24,
        show:this.isPort&& this.isAdd ,
				options: this.getWarehouseType,				
      },{
				label: this.$t('erp.b2c.product_orgwarehouse', { defaultValue: '仓库' }),
				key: this.isAdd ? "depotId" : "purposeDepot",
        tag: "vSelect",
        span:24,
        query:!this.isAdd,
        show:(this.isPort&&!this.isAdd),
        options: this.isAdd ? this.getFBBFilterDisabledAllWarehouse : null,		
        props: {
        filterable: true
            },		
			}, {
				label: this.$t('erp.b2c.product_orgwarehouse', { defaultValue: '仓库' }),
				key: this.isAdd ? "depotId" : "purposeDepot",
        tag: "vSelect",
        span:24,
        query:!this.isAdd,
        show:(this.isPort&&this.isWarehouse&&this.isAdd)||this.isPallet,
        options: this.isAdd ? this.getFBBFilterDisabledAllWarehouse : null,		
        props: {
        filterable: true
            },		
			}, {
				label: this.$t('fbb.logistics.time_amazon_depot', { defaultValue: '亚马逊门店' }),
				key: this.isAdd ? "depotId" : "purposeDepot",
        tag: "vSelect",
        span:24,
        show:this.isPort&&!this.isWarehouse&&this.isAdd,
				options: this.isAdd ? this.addressCodeList : null,				
			}, {
				label: this.$t('	fbb.inbound.amazon_warehouse', { defaultValue: '亚马逊仓' }),
				key: this.isAdd ? "amazonId" : "amazonFc",
        tag: "vSelect",
        query:!this.isAdd,
        span:24,
        show:this.isAmazon,
				options: this.isAdd ? this.addressCodeList : null,					
			}, {
        label: this.$t('fbb.logistics.cost_amazon_address', { defaultValue: '亚马逊地址详情' }),
        key:"addressDetail",
        tag: "vInput",
        query:true,
        span:24,
        show:this.isAmazon&&!this.isAdd,				
			},{
        label: this.$t('fbb.logistics.time_wait', { defaultValue: '等待时间(天)' }),
        span:24,
        key: "timeQuantity", 
				tag: "vInputNumber",			
			}
      ];
     }
        
  },
  methods: {
      getDetail() {
      if (this.isAdd) return;
      this.loading = true;
      if(this.id){
          HttpGetOne({ id: this.id }).then(res => {
					
          this.formData = res.data;
          if(this.isPort){
            if(this.formData.depotType===2){
              this.formData.destinationType = 1
            }else{
              this.formData.destinationType = 0
            }
          }
           if(this.isAmazon){
             this.formData.addressDetail=""
             HttpAddressList({
               'search[EQ_warehouseType]':2,
                    'search[EQ_id]':this.formData.amazonId,
                    rows: 1000,
                }).then(res=>{
                  this.formData.addressDetail = "国家:"+res.data.content[0].country+" 州/省:"
                   +res.data.content[0].state+" 城市:"+res.data.content[0].city+" 详细地址:"+res.data.content[0].address
                   +" 邮编:"+res.data.content[0].postal+" 联系人:"+res.data.content[0].linkman+" 联系电话:"+res.data.content[0].phone;
                this.loading = false;
                },err=>{
                  this.$VMessage.error(err.message);
                })
          }else{
              this.loading = false;
          }
				}).catch(err => {
					this.loading = false;
					this.$VMessage.error(err.message);
				})
      }
    },
    getAddress(){
      if (!this.isAdd) return;
      if(this.isPort||this.isAmazon){
           HttpAddressList({
                    'search[EQ_warehouseType]':2,
                    rows: 1000,
                }).then(res=>{
                    this.addressCodeList = res.data.content.map(item => {
                return {
                    label: item.code,
                    value: item.id
                } })
                },err=>{
                    this.$VMessage.error(err.message);
                })
      }
    },
    async submit(){
        const valid = await this.$refs.formbase.validate();
        if (!valid) return;
        if(this.isOcean){
            if(this.formData.purposePortId==this.formData.shipPortId){
                this.$VMessage.error(this.$t('fbb.logistics.cost_check_port', { defaultValue: '发运港与目的港不能相同！' }))
                return
            }
        }
        if(!(/(^[1-9]\d*$)/.test(this.formData.timeQuantity))){
                this.$VMessage.error(this.$t('fbb.logistics.cost_check_num', { defaultValue: '请输入大于0的数' }))
                return
        }
        this.loading = true;
        HttpSaveTimePrediction({
          id:this.activeid,
          organizationId: global.SYSID,
          type: this.timeType,
          content: this.formData,
        })
          .then(res => {
            this.loading = false;
            this.$VMessage.success(this.$t('fbb.logistics.cost_add_success', { defaultValue: '添加成功' }));
            this.success();
          }, err => {
            this.loading = false;
                this.$VMessage.error(err.message)
            });
    },
   
    success() {
      this.$emit("on-close");
      this.$emit("on-update");
      this.$emit("refreshPage");
    },
    cancel() {
      this.$emit("on-close");
    }
  }
};
</script>
